<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">

  <mat-tree-node #tree *matTreeNodeDef="let node" (click)="setActiveNode(node)" matTreeNodePadding id="tree-select-{{node.uniqueIdentifier}}">

    <button mat-icon-button [attr.aria-label]="'toggle ' + node.filename"
      [disabled]="!node.allowAddChildren"
      matTreeNodeToggle>

      @if (node.expandable) {
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      }
    </button>

    <span class="tree-node" ng-class="{'tree-node-selected': node === selectedNode}">
      <mat-icon class="tree-node-icon">{{node.icon}}</mat-icon>
      <span class="tree-node-text">{{node.name}}</span>
      @if (node === selectedNode) {
        <span class="tree-node-edit">
          @if (node.allowAddChildren) {
            <mat-icon class="tree-node-add-child" tabindex="0" role="button" (click)="clickAddNode(node)" (keydown.enter)="clickAddNode(node)" (keydown.space)="clickAddNode(node); $event.preventDefault()" id="tree-add-{{node.uniqueIdentifier}}">add_box</mat-icon>
          }
          @if (node.allowDelete) {
            <mat-icon class="tree-node-delete" tabindex="0" role="button" (click)="clickDeleteNode(node)" (keydown.enter)="clickDeleteNode(node)" (keydown.space)="clickDeleteNode(node); $event.preventDefault()" id="tree-delete-{{node.uniqueIdentifier}}">delete</mat-icon>
          }
        </span>
      }
    </span>

  </mat-tree-node>
</mat-tree>